// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable multiline-comment-style, no-negated-condition */
import cuckoo from "../cuckoo/cuckoo"
import { cuckooEvents } from "../../consts/enums"
import type { LanguageInfo } from "../../records/LanguageInfo"

/*
 try/catch block is important when we disable a currency,
 in which there are already some bookings
*/

// @ts-expect-error: Flow to TS migration.
const formatThousands = (price: string, separator: string) => {
  const { length } = price
  if (length <= 3) {
    return price
  }
  const start = price.slice(0, length - 3)
  const end = price.slice(length - 3)
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  return formatThousands(start, separator) + separator + end
}

// Return number of decimal places of num:string
function decimalPlaces(num: string) {
  const [, right] = num.split(".")
  return right ? right.length : 0
}

function formatPriceThousandsAndDecimals(price: string, langInfo: LanguageInfo) {
  const { decimalSeparator } = langInfo
  const thousandsSeparator =
    langInfo.thousandsSeparator === "nbsp" ? " " : langInfo.thousandsSeparator
  const separateFourDigits = langInfo.separateFourDigits === "1"

  const numOfDecimalPlaces = decimalPlaces(price.toString())
  const floatPrice = parseFloat(price)

  // Price can also be negative. E.g. promocode
  const priceStr = Math.abs(floatPrice).toFixed(numOfDecimalPlaces)

  const [full, decimal] = priceStr.split(".")
  let formattedFull = floatPrice < 0 ? "-" : ""

  // Some languages do not separate 4 digits price. Like $3452 but $11.232 is still separated
  if (full.length === 4 && !separateFourDigits) {
    formattedFull += full
  } else {
    formattedFull += formatThousands(full, thousandsSeparator)
  }

  return decimal ? formattedFull + decimalSeparator + decimal : formattedFull
}

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
export function getSymbol(currencyCode: string, currencies: FetchedCurrencies) {
  try {
    return currencies[currencyCode.toLowerCase()].format.replace("__price__", "").trim()
  } catch (err) {
    cuckoo.error(cuckooEvents.GENERAL_UNSUPPORTED_CURRENCY, { currency: currencyCode })

    return currencyCode
  }
}

function getFormattedPrice(opts: {
  currencyCode: string
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line no-undef
  currencies: FetchedCurrencies
  price: string
}) {
  const { currencyCode, currencies, price } = opts
  try {
    return currencies[currencyCode.toLowerCase()].format.replace("__price__", price)
  } catch (err) {
    cuckoo.error(cuckooEvents.GENERAL_UNSUPPORTED_CURRENCY, { currency: currencyCode })

    return `${price} ${currencyCode}`
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
export const roundPrice = (amount: number, currencyCode: string, currencies: FetchedCurrencies) => {
  const precision = currencies[currencyCode] ? currencies[currencyCode].precision : 2
  return amount.toFixed(precision)
}

export const formatPrice = (
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line no-undef
  currencies: FetchedCurrencies,
  langInfo: LanguageInfo,
  currencyCode: string,
  price: number,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  formatThousandsAndDecimals: boolean = true,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  separatePrice: boolean = false,
) => {
  // @ts-expect-error: Flow to TS migration.
  const floatPrice = parseFloat(price)
  const finalPrice =
    Math.round(floatPrice) !== floatPrice
      ? roundPrice(floatPrice, currencyCode, currencies)
      : String(floatPrice)
  const formattedPrice = formatThousandsAndDecimals
    ? formatPriceThousandsAndDecimals(finalPrice, langInfo)
    : finalPrice

  const opts = {
    currencyCode,
    currencies,
    price: separatePrice ? `<span class='price-value'>${formattedPrice}</span>` : formattedPrice,
  } as const
  return getFormattedPrice(opts)
}

export function formatISO4217Price(opts: {
  langInfo: LanguageInfo
  formatThousandsAndDecimals: boolean
  price: string
  currencyCode: string
}) {
  const { langInfo, formatThousandsAndDecimals } = opts
  let { price } = opts
  const { currencyCode } = opts

  if (formatThousandsAndDecimals) {
    price = formatPriceThousandsAndDecimals(price, langInfo)
  }

  return `${currencyCode.toUpperCase()} ${price}`
}

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line no-undef
export function getCurrencyName(currencyCode: string, currencies: FetchedCurrencies) {
  try {
    return currencies[currencyCode].name
  } catch (err) {
    cuckoo.error(cuckooEvents.GENERAL_UNSUPPORTED_CURRENCY, { currency: currencyCode })

    return currencyCode
  }
}
